import React, { useState } from "react";
import { Eye, EyeOff } from "lucide-react";
import { Input } from "@/components/ui/input";

/**
 * PasswordInput — an <Input> with a show/hide toggle button.
 * Accepts every native input prop plus optional `testId` and `invalid`.
 */
export default function PasswordInput({ testId, className, invalid, ...props }) {
  const [visible, setVisible] = useState(false);
  return (
    <div className="relative">
      <Input
        {...props}
        type={visible ? "text" : "password"}
        aria-invalid={invalid ? "true" : undefined}
        data-testid={testId}
        className={`pr-10 ${className || ""}`}
      />
      <button
        type="button"
        onClick={() => setVisible((v) => !v)}
        className="absolute right-2 top-1/2 -translate-y-1/2 h-8 w-8 grid place-items-center rounded-md text-muted-foreground hover:text-foreground hover:bg-secondary/60 transition-colors"
        aria-label={visible ? "Hide password" : "Show password"}
        aria-pressed={visible}
        data-testid={testId ? `${testId}-toggle` : undefined}
        tabIndex={-1}
      >
        {visible ? <EyeOff className="w-4 h-4" /> : <Eye className="w-4 h-4" />}
      </button>
    </div>
  );
}
